// @ts-nocheck
import { Workbox } from "workbox-window";

let wb;

// Check if service worker is enabled in config
const isServiceWorkerEnabled = process.env.NODE_ENV === 'production' && 
                              !process.env.VUE_APP_DISABLE_SW &&
                              false; // Temporarily disable PWA completely

if ('serviceWorker' in navigator && isServiceWorkerEnabled) {
  wb = new Workbox(`${process.env.BASE_URL}service-worker.js`);
  
  const showSkipWaitingPrompt = async () => {
    wb.addEventListener('controlling', () => {
      window.location.reload();
    });
    
    // Simple prompt for update - you can customize this
    const updateAccepted = window.confirm('A new version is available. Would you like to update?');

    if (updateAccepted) {
      wb.messageSkipWaiting();
    }
  };

  wb.addEventListener('waiting', (event) => {
    showSkipWaitingPrompt(event);
  });

  wb.register();
} else {
  wb = null;
}

export default wb;